import React from 'react';
import { Input } from './input';
import { SimpleTooltip } from './SimpleTooltip';

interface CallerIdInputProps {
  id?: string;
  nameValue: string;
  numberValue: string;
  onNameChange: (value: string) => void;
  onNumberChange: (value: string) => void;
  namePlaceholder?: string;
  numberPlaceholder?: string;
  nameTooltip?: string;
  numberTooltip?: string;
  className?: string;
  disabled?: boolean;
  nameError?: string;
  numberError?: string;
}

export function CallerIdInput({
  id,
  nameValue,
  numberValue,
  onNameChange,
  onNumberChange,
  namePlaceholder = "Name",
  numberPlaceholder = "Number",
  nameTooltip,
  numberTooltip,
  className = "",
  disabled = false,
  nameError,
  numberError,
}: CallerIdInputProps) {
  return (
    <div className={`flex flex-col sm:flex-row gap-2 min-w-0 ${className}`}>
      <SimpleTooltip content={nameTooltip}>
        <Input
          id={`${id}-name`}
          value={nameValue}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder={namePlaceholder}
          disabled={disabled}
          error={nameError}
          className="flex-1 min-w-0"
        />
      </SimpleTooltip>
      <SimpleTooltip content={numberTooltip}>
        <Input
          id={`${id}-number`}
          value={numberValue}
          onChange={(e) => onNumberChange(e.target.value)}
          placeholder={numberPlaceholder}
          disabled={disabled}
          error={numberError}
          className="flex-1 min-w-0"
        />
      </SimpleTooltip>
    </div>
  );
}
